import { render } from "./FreeTradeAgreementTypes.vue?vue&type=template&id=0e816be1"
import script from "./FreeTradeAgreementTypes.vue?vue&type=script&lang=js"
export * from "./FreeTradeAgreementTypes.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__